import React, { Component } from 'react'
import { list } from './apiPost';
import { Link } from 'react-router-dom';
import DefaultImage from '../assets/default-post.jpg';
import LoadingAnim from '../core/LoadingAnim';

class Posts extends Component {
    constructor() {
        super()
        this.state = {
            posts: []
        }
    }

    componentDidMount() {
        list().then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({ posts: data });
            }
        });
    }

    renderPosts = posts => {
        return (
            <div className="row">
                {posts.map((post, i) => {
                    const posterId = post.postedBy ? `/user/${post.postedBy._id}` : '';
                    const posterName = post.postedBy ? post.postedBy.name : 'Unknown';
                    return (
                        <div className="card col-md-4 col-sm-6 mb-2" key={i}>
                            <img
                                className="card-img-top mt-4 img-thumbnail img-fluid"
                                style={{ width: 'auto', maxHeight: 175, margin: 'auto' }}
                                src={`${process.env.REACT_APP_API_URL}/post/photo/${post._id}`}
                                onError={i => (i.target.src = `${DefaultImage}`)}
                                alt={post.title}
                            />
                            <div className="card-body">
                                <h5 className="card-title">{post.title}</h5>
                                <p className="card-text">{post.body.substring(0, 100)}...</p>
                                <p className="font-italic mark">
                                    Posted by: <Link to={`${posterId}`}>{posterName}</Link>
                                    <br />Date: {new Date(post.created).toDateString()}
                                </p>
                                <br style={{ clear: 'both' }} />
                                <p><Link to={`/post/${post._id}`} className="btn btn-raised btn-primary btn-sm" style={{ position: 'absolute', bottom: 15 }}>View Post</Link></p>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }

    render() {
        const { posts } = this.state;
        return (
            <div className="container">
                <h2 className="mt-5">{!posts.length ? 'Loading...' : 'Recent Posts'}</h2>
                {!posts.length ? <LoadingAnim /> : this.renderPosts(posts)}
            </div>
        )
    }
}

export default Posts;
